module.exports = __webpack_public_path__ + "img/Grinding_stock.b4aee685.svg";